import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-content-nav-chapter',
  templateUrl: './content-nav-chapter.component.html',
  styleUrls: ['./content-nav-chapter.component.scss']
})
export class ContentNavChapterComponent implements OnInit {

  @Input() chapter: any = null;
  @Input() active: any = null;
  @Output() clicked = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  onChapterClicked(id: string): void {
    this.clicked.emit(id);
  }

}
